import imgT1 from "../assets/image/jpg/fitnessThree.jpg";
import imgT2 from "../assets/image/jpg/P4.jpg";
import imgT3 from "../assets/image/jpg/adidasSeven.jpg";
import imgT4 from "../assets/image/jpg/mic.jpg";
import imgT5 from "../assets/image/jpg/plants.jpg";
import imgT6 from "../assets/image/jpg/spaceman.jpg";
import imgT7 from "../assets/image/jpg/threejs.png";
import imgT8 from "../assets/image/jpg/siteHeader.jpg";
import imgT9 from "../assets/image/jpg/staff-2.jpg"

export const devWorks2 = [
  {
    brand: `Grubspace`,
    slug: `grubspace`,
    title: `Fullstack Team Development`,
    categories: [`web`],
    thumbnail: imgT9,
    link: "https://grubspace.netlify.app",
  },
  {
    brand: `Anywhere Fitness`,
    slug: `anywhere-fitness`,
    title: `Fullstack Team Development`,
    categories: [`web`],
    thumbnail: imgT1,
    link: "https://anywhere-fitness-club.vercel.app",
  },
  {
    brand: `Street Art Magazine`,
    slug: `street-art`,
    title: `Fullstack Development`,
    categories: [`web`],
    thumbnail: imgT2,
    link: "https://streetartmagazine.netlify.app/",
  },
  {
    brand: `Adidas Product Portal`,
    slug: `adidas-product-portal`,
    title: `Fullstack Development`,
    categories: [`web`, `ui-design`],
    thumbnail: imgT3,
    link: "https://adidasproductportal.vercel.app/",
  },
  {
    brand: `Water My Plants`,
    slug: `water-my-plants`,
    title: `UI and form design`,
    categories: [`app`, `ui-design`],
    thumbnail: imgT5,
    link: "https://watermy-plants.netlify.app/",
  },
  // {
  //   brand: `Anywhere Fitness Club`,
  //   slug: `anywhere-fitness`,
  //   title: `Full stack team build`,
  //   categories: [ `web`],
  //   thumbnail: imgT1,
  //   link: "https://anywhere-fitness-club.vercel.app/",
  // },
  {
    brand: `Space Digest`,
    slug: `space-digest`,
    title: `API consumption Frontend development `,
    categories: ["Web"],
    thumbnail: imgT6,
    link: "https://spacedigest.netlify.app/",
  }, 
  {
    brand: `Syntech Industries`,
    slug: `syntech-industries`,
    title: `3D animation landing page`,
    categories: [`3D Animation`],
    thumbnail: imgT7,
    link: "https://syntech3d.netlify.app/",
  },
  {
    brand: `Anime House`,
    slug: `anime-house`,
    title: `API consuming frontend development`,
    categories: [ `ui-design`],
    thumbnail: imgT8,
    link: "https://animehouse.vercel.app/",
  }
 
];
